import * as React from "react";
const SvgNowhere = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#5E6C84"
      fillRule="evenodd"
      d="M8 1.333A6.67 6.67 0 0 0 1.333 8 6.669 6.669 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333ZM2.667 8A5.332 5.332 0 0 1 8 2.667c1.233 0 2.367.42 3.267 1.126l-7.474 7.474A5.268 5.268 0 0 1 2.667 8Zm2.066 4.207A5.268 5.268 0 0 0 8 13.333 5.332 5.332 0 0 0 13.333 8c0-1.233-.42-2.367-1.126-3.267l-7.474 7.474Z"
      clipRule="evenodd"
    />
    <mask
      id="nowhere_svg__a"
      width={14}
      height={14}
      x={1}
      y={1}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path
        fill="#5E6C84"
        fillRule="evenodd"
        d="M8 1.333A6.67 6.67 0 0 0 1.333 8 6.669 6.669 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333ZM2.667 8A5.332 5.332 0 0 1 8 2.667c1.233 0 2.367.42 3.267 1.126l-7.474 7.474A5.268 5.268 0 0 1 2.667 8Zm2.066 4.207A5.268 5.268 0 0 0 8 13.333 5.332 5.332 0 0 0 13.333 8c0-1.233-.42-2.367-1.126-3.267l-7.474 7.474Z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#nowhere_svg__a)">
      <path fill="#5E6C84" d="M0 0h16v16H0z" />
    </g>
  </svg>
);
export default SvgNowhere;
